define('models/pages/trade/request/processed/index',['require','underscore','chaplin','models/base/collection','models/base/modal'],function(require) {
    'use strict';

    var _ = require('underscore'),
        Chaplin = require('chaplin'),
        Collection = require('models/base/collection'),
        ModalModel = require('models/base/modal');

    var ProcessedCollection = Collection.extend({
        initialize: function() {
            Collection.prototype.initialize.apply(this, arguments);
            _.extend(this, Chaplin.SyncMachine);
        }
    });

    var ProcessedModalModel = ModalModel.extend({
        urlPath: '/request-processed',
        defaults: {
            'title': 'Обработка заказа',
            'buttons': [
                { caption: 'Закрыть', className: '', 'action': 'cancel' }
            ],
            body: ''
        },
        constructor: function() {
            ModalModel.apply(this, arguments);

            this.items = new ProcessedCollection();

            this.on('beforeLoad', function() {
                this.items.beginSync();
            });

            this.on('afterLoad', function() {
                this.items.finishSync();
            });
        },
        parse: function(data) {
            var items = data && data.items || [];
            var sumAmount = 0;

            for (var i=0, l=items.length-1; i<l; i++) {
                sumAmount += items[i].replaceAmount || items[i].amount;
            }

            var lastItem = items[l];

            if (sumAmount < lastItem.amount) {
                lastItem.amount = lastItem.amount - sumAmount;
            } else {
                items.pop();
            }

            this.items.reset(items);

            return data;
        },
        urlParams: function() {
            var params = ModalModel.prototype.urlParams.apply(this, arguments);
            params.requestId = this.get('requestId');
            return params;
        },
    });

    return ProcessedModalModel;
});
